import React from 'react';

const WidgetSettingsContent = ({ children }) => (
	<div className='modal-content' style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
		{children}
	</div>
);

export default WidgetSettingsContent;
